import RawModel from "../models/rawModel";
import FilterItemModel from "../models/filterItemModel";
import mapObject from "lodash/mapValues";
import sortBy from "lodash/sortBy";
import groupBy from "lodash/groupBy";
import { saveAs } from "./globalUtils";
import each from "lodash/each";
import { fetchRawData } from "../actions/rawDataActions";

export const parseAllStations = (sensors) => {
  if (!sensors) return sensors;
  // Loading the sensors in the sensor models
  sensors = sensors.map(function (sensor) {
    // Rewrite the latest measurements
    var s = new RawModel({
      id: sensor.id,
      product: sensor.product,
      name: sensor.name,
      owner: sensor.owner,
      latitude: sensor.latitude,
      longitude: sensor.longitude,
      type: sensor.sensor_type
        ? sensor.sensor_type.charAt(0).toUpperCase() + sensor.sensor_type.slice(1)
        : "",
      enabled: sensor.powered_on,
      active: sensor.has_recent_measurements,
      activePeriodStart: sensor.active_period_start,
      activePeriodEnd: sensor.active_period_end,
      latestMeasurement: sensor.latest_measurement_ts,
      serialNumber: sensor.serial_number,
      meta: sensor.meta,
    });

    return s;
  });

  var typeFilter = groupBy(sensors, "type");
  var ownerFilter = groupBy(sensors, "owner");
  var periodFilter = groupBy(sensors, "period");

  if (!periodFilter.future) periodFilter.future = [];
  if (!periodFilter.past) periodFilter.past = [];
  if (!periodFilter.now) periodFilter.now = [];
  if (!periodFilter.none) periodFilter.none = [];

  // Get filter status from the url parameters to enable sensors on beforehand
  // var urlParameters = QueryString.parse(location.search);

  var filterIdCount = 0;

  var filters = {
    type: mapObject(typeFilter, function (filterItem, title) {
      filterIdCount++;
      return new FilterItemModel(filterIdCount, title, "type", filterItem.length, false);
    }),

    owner: mapObject(ownerFilter, function (filterItem, title) {
      filterIdCount++;
      return new FilterItemModel(filterIdCount, title, "owner", filterItem.length, false);
    }),

    period: mapObject(periodFilter, function (filterItem, title) {
      filterIdCount++;
      return new FilterItemModel(
        filterIdCount,
        title,
        "period",
        filterItem.length,
        title === "now"
      );
    }),
  };

  // Sort and order the filters
  filters.group = sortBy(filters.group, "title");
  filters.type = sortBy(filters.type, "title");
  filters.owner = sortBy(filters.owner, "title");

  // Only show the new filter if there are new sensors
  var nonePeriodSensors;
  if (filters.period.none.count > 0) {
    nonePeriodSensors = filters.period.none;
  }

  filters.period = [filters.period.now, filters.period.future, filters.period.past];

  if (nonePeriodSensors) {
    filters.period.push(nonePeriodSensors);
  }

  sensors = sortBy(sensors, "name");

  return { sensors, filters };
};

export const parseRawData = (station) => {
  if (!station) return station;
  let parsedStation = new RawModel({
    id: station.id,
    name: station.name, //+url,
    latitude: station.latitude,
    longitude: station.longitude,
    enabled: station.powered_on,
    active: station.has_recent_measurements,
    activePeriodStart: station.active_period_start,
    activePeriodEnd: station.active_period_end,
    serialNumber: station.serial_number,
    latestMeasurement: station.latest_measurement_ts,
    meta: station.meta,
  });

  // Calculate the timezone offset
  var d = new Date();
  var timezoneOffset = d.getTimezoneOffset() * 60000;

  // save the raw measurements
  parsedStation.measurements = station.raw_measurements;
  // The last data point we received
  var ldp = false;
  let firstDataPointTimestamp = false;
  if (station.raw_measurements[0]) {
    firstDataPointTimestamp = station.raw_measurements[0].timestamp;
    ldp = parsedStation.measurements[parsedStation.measurements.length - 1];
  }

  var lastDataPoint;
  var firstDataPoint;
  const domain = [];
  if (ldp && firstDataPointTimestamp) {
    lastDataPoint = new Date(parseInt(ldp.timestamp * 1000 + timezoneOffset));
    firstDataPoint = new Date(parseInt(firstDataPointTimestamp * 1000 + timezoneOffset));
    domain.push(new Date(firstDataPointTimestamp * 1000 + timezoneOffset));
    domain.push(ldp.timestamp);
  }

  parsedStation.firstDataPointDate = firstDataPoint;
  parsedStation.lastDataPointDate = lastDataPoint;

  return { sensor: parsedStation, lastDataPoint, defaultDomain: domain };
};

export const export2csv = (station) => {
  var valuescsv = "date\ttime";
  var d = new Date();
  var offset = d.getTimezoneOffset() * 1000 * 60;
  //output the table header
  each(station.meta, function (key) {
    valuescsv += "\t" + key.key;
  });

  //output the actual measurement values
  each(station.measurements, function (measurement, key) {
    valuescsv += "\r\n";
    var ts = new Date(measurement.timestamp * 1000 + offset);

    valuescsv += ts.toLocaleDateString().replace(/\u200e/g, "") + "\t"; // the unicode 200e sign is an IE bug, so remove those characters.
    valuescsv += ts.toLocaleTimeString().replace(/\u200e/g, "");

    for (var i = 0; i < measurement.values.length; i++) {
      var mval = measurement.values[i];
      if (mval) {
        valuescsv +=
          "\t" +
          mval.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        valuescsv += "\t";
      }
    }
  });
  saveAs(valuescsv, "dacom_raw_data.csv");
};

// Callback used by `DateRangeField` replacement. Converts the picked range into
// the UTC-offset-adjusted seconds window that `fetchRawData` expects.
export const applyFullDateRange = (apiUrl, station, dispatch) => (start, end) => {
  const offset = new Date().getTimezoneOffset() * 60;
  dispatch(
    fetchRawData(apiUrl, station.id, [
      Math.round(start.getTime() / 1000) - offset,
      Math.round(end.getTime() / 1000) - offset,
    ])
  );
};
